import React from "react"

const Tire360CartFooter = ({ children }) => {
  return <div className="tire-360-cart-footer">{children}</div>
}

export default Tire360CartFooter
